var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 700,
    viewBox: "0 0 370.41667 185.20834",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    transform: "matrix(1.0190162,0,0,1.0190162,-13.456808,-9.0903045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1201",
    style: {
      display: "inline",
      fill: "#e3dedb"
    },
    transform: "matrix(2.1647172,0,0,2.1647172,193.97616,38.360828)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect409",
    width: 2,
    height: 2,
    x: 6.3000002,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect411",
    width: 2,
    height: 2,
    x: 8.3999996,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect413",
    width: 2,
    height: 2,
    x: 8.3999996,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect415",
    width: 2,
    height: 2,
    x: 8.3999996,
    y: 4.1999998
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect417",
    width: 2,
    height: 2,
    x: 10.5,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect419",
    width: 2,
    height: 2,
    x: 10.5,
    y: 4.2000012
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect421",
    width: 2,
    height: 2,
    x: 10.5,
    y: 2.0999999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect423",
    width: 2,
    height: 2,
    x: 12.6,
    y: 4.2000022
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect425",
    width: 2,
    height: 2,
    x: 12.6,
    y: 2.1000018
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect427",
    width: 2,
    height: 2,
    x: 12.6,
    y: -1.3877788e-17
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect429",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect431",
    width: 2,
    height: 2,
    x: 0,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect433",
    width: 2,
    height: 2,
    x: -2.0999999,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect435",
    width: 2,
    height: 2,
    x: -9.8049645e-7,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect437",
    width: 2,
    height: 2,
    x: -2.1000011,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect439",
    width: 2,
    height: 2,
    x: -4.1999998,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect441",
    width: 2,
    height: 2,
    x: -2.1000032,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect443",
    width: 2,
    height: 2,
    x: -4.2000027,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect445",
    width: 2,
    height: 2,
    x: -6.3000002,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect447",
    width: 2,
    height: 2,
    x: 6.3000002,
    y: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect449",
    width: 2,
    height: 2,
    x: 4.1999998,
    y: 16.799999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect451",
    width: 2,
    height: 2,
    x: 4.1999998,
    y: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect453",
    width: 2,
    height: 2,
    x: 4.1999998,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect455",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect457",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect459",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 23.1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect461",
    width: 2,
    height: 2,
    x: -1.3877788e-17,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect463",
    width: 2,
    height: 2,
    x: -1.3877788e-17,
    y: 23.1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.264583
    },
    id: "rect465",
    width: 2,
    height: 2,
    x: -1.3877788e-17,
    y: 25.200001
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1170",
    style: {
      display: "inline",
      fill: "#ff0000",
      fillOpacity: 1
    },
    transform: "matrix(2.1647172,0,0,2.1647172,193.97616,38.360828)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect316",
    width: 2,
    height: 2,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect318",
    width: 2,
    height: 2,
    x: 0,
    y: 2.0999999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect320",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 2.0999999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect329",
    width: 2,
    height: 2,
    x: 0,
    y: 4.1999998
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect331",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 4.1999998
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect337",
    width: 2,
    height: 2,
    x: 4.1999998,
    y: 4.1999998
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect339",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect341",
    width: 2,
    height: 2,
    x: 4.1999998,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect343",
    width: 2,
    height: 2,
    x: 4.1999998,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect347",
    width: 2,
    height: 2,
    x: 4.1999998,
    y: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect349",
    width: 2,
    height: 2,
    x: 2.0999999,
    y: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect351",
    width: 2,
    height: 2,
    x: 0,
    y: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect353",
    width: 2,
    height: 2,
    x: -2.0999999,
    y: 14.7
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect355",
    width: 2,
    height: 2,
    x: -8.5383653e-7,
    y: 16.799999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect357",
    width: 2,
    height: 2,
    x: -2.1000009,
    y: 16.799999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect359",
    width: 2,
    height: 2,
    x: -4.1999998,
    y: 16.799999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect361",
    width: 2,
    height: 2,
    x: -2.1000025,
    y: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect363",
    width: 2,
    height: 2,
    x: -4.2000017,
    y: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect365",
    width: 2,
    height: 2,
    x: -6.3000002,
    y: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect369",
    width: 2,
    height: 2,
    x: 8.3999996,
    y: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect373",
    width: 2,
    height: 2,
    x: 8.3999996,
    y: 16.799999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect375",
    width: 2,
    height: 2,
    x: 8.3999996,
    y: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect377",
    width: 2,
    height: 2,
    x: 8.3999996,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect379",
    width: 2,
    height: 2,
    x: 10.5,
    y: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect381",
    width: 2,
    height: 2,
    x: 10.5,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect383",
    width: 2,
    height: 2,
    x: 10.5,
    y: 23.1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect385",
    width: 2,
    height: 2,
    x: 12.6,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect387",
    width: 2,
    height: 2,
    x: 12.6,
    y: 23.1
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect389",
    width: 2,
    height: 2,
    x: 12.6,
    y: 25.200001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect391",
    width: 2,
    height: 2,
    x: 10.5,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect393",
    width: 2,
    height: 2,
    x: 12.6,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect395",
    width: 2,
    height: 2,
    x: 14.7,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect397",
    width: 2,
    height: 2,
    x: 12.6,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect399",
    width: 2,
    height: 2,
    x: 14.700001,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect401",
    width: 2,
    height: 2,
    x: 16.799999,
    y: 8.3999996
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect403",
    width: 2,
    height: 2,
    x: 14.7,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect405",
    width: 2,
    height: 2,
    x: 16.800003,
    y: 6.3000002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    id: "rect407",
    width: 2,
    height: 2,
    x: 18.900005,
    y: 6.3000002
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    transform: "matrix(2.1850719,0,0,2.1850719,-28.126798,-157.81004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g574",
    style: {
      display: "inline",
      fill: "#0000ff",
      fillOpacity: 1
    },
    transform: "translate(-9.8394929)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect553",
    width: 4.3294344,
    height: 4.3294344,
    x: 25,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect556",
    width: 4.3294344,
    height: 4.3294344,
    x: 25,
    y: 140.60001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect558",
    width: 4.3294344,
    height: 4.3294344,
    x: 25,
    y: 136.2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect560",
    width: 4.3294344,
    height: 4.3294344,
    x: 25,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect562",
    width: 4.3294344,
    height: 4.3294344,
    x: 25,
    y: 127.40001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect564",
    width: 4.3294344,
    height: 4.3294344,
    x: 25,
    y: 123.00003
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect566",
    width: 4.3294344,
    height: 4.3294344,
    x: 25,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect578",
    width: 4.3294344,
    height: 4.3294344,
    x: 29.4,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect580",
    width: 4.3294344,
    height: 4.3294344,
    x: 33.799999,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect582",
    width: 4.3294344,
    height: 4.3294344,
    x: 38.200001,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect584",
    width: 4.3294344,
    height: 4.3294344,
    x: 42.599998,
    y: 140.60001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect586",
    width: 4.3294344,
    height: 4.3294344,
    x: 42.599998,
    y: 136.2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect588",
    width: 4.3294344,
    height: 4.3294344,
    x: 42.599998,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect590",
    width: 4.3294344,
    height: 4.3294344,
    x: 42.599998,
    y: 127.40001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect592",
    width: 4.3294344,
    height: 4.3294344,
    x: 42.599998,
    y: 123.00003
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect594",
    width: 4.3294344,
    height: 4.3294344,
    x: 29.4,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect596",
    width: 4.3294344,
    height: 4.3294344,
    x: 33.799999,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0000ff",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect598",
    width: 4.3294344,
    height: 4.3294344,
    x: 38.200001,
    y: 145
  })), /*#__PURE__*/React.createElement("g", {
    id: "g666",
    style: {
      display: "inline",
      fill: "#ffff00",
      fillOpacity: 1
    },
    transform: "translate(-7.8394932)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect600",
    width: 4.3294344,
    height: 4.3294344,
    x: 48,
    y: 145.00005
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect604",
    width: 4.3294344,
    height: 4.3294344,
    x: 52.400002,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect606",
    width: 4.3294344,
    height: 4.3294344,
    x: 56.799999,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect608",
    width: 4.3294344,
    height: 4.3294344,
    x: 61.200001,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect610",
    width: 4.3294344,
    height: 4.3294344,
    x: 48,
    y: 140.60001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect612",
    width: 4.3294344,
    height: 4.3294344,
    x: 48,
    y: 136.2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect614",
    width: 4.3294344,
    height: 4.3294344,
    x: 48,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect616",
    width: 4.3294344,
    height: 4.3294344,
    x: 48,
    y: 127.39999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect618",
    width: 4.3294344,
    height: 4.3294344,
    x: 48,
    y: 123.00004
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect620",
    width: 4.3294344,
    height: 4.3294344,
    x: 48,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect622",
    width: 4.3294344,
    height: 4.3294344,
    x: 65.599998,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect624",
    width: 4.3294344,
    height: 4.3294344,
    x: 52.400002,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect626",
    width: 4.3294344,
    height: 4.3294344,
    x: 56.799999,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect628",
    width: 4.3294344,
    height: 4.3294344,
    x: 61.200001,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect630",
    width: 4.3294344,
    height: 4.3294344,
    x: 52.400002,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect632",
    width: 4.3294344,
    height: 4.3294344,
    x: 56.799999,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect634",
    width: 4.3294344,
    height: 4.3294344,
    x: 61.200001,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffff00",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect636",
    width: 4.3294344,
    height: 4.3294344,
    x: 65.600006,
    y: 118.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g707",
    style: {
      display: "inline",
      fill: "#ff0000",
      fillOpacity: 1
    },
    transform: "translate(-5.8394934)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect638",
    width: 4.3294344,
    height: 4.3294344,
    x: 71,
    y: 136.20004
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect640",
    width: 4.3294344,
    height: 4.3294344,
    x: 71,
    y: 131.80005
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect642",
    width: 4.3294344,
    height: 4.3294344,
    x: 71,
    y: 127.39997
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect644",
    width: 4.3294344,
    height: 4.3294344,
    x: 71,
    y: 123.00004
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect646",
    width: 4.3294344,
    height: 4.3294344,
    x: 71,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect668",
    width: 4.3294344,
    height: 4.3294344,
    x: 75.400002,
    y: 140.60001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect670",
    width: 4.3294344,
    height: 4.3294344,
    x: 79.800003,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect672",
    width: 4.3294344,
    height: 4.3294344,
    x: 84.199997,
    y: 140.60001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect674",
    width: 4.3294344,
    height: 4.3294344,
    x: 88.599998,
    y: 136.20004
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect676",
    width: 4.3294344,
    height: 4.3294344,
    x: 88.599998,
    y: 131.80005
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect678",
    width: 4.3294344,
    height: 4.3294344,
    x: 88.599998,
    y: 127.39997
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect680",
    width: 4.3294344,
    height: 4.3294344,
    x: 88.599998,
    y: 123.00004
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff0000",
      fillOpacity: 1,
      strokeWidth: 0.572747
    },
    id: "rect682",
    width: 4.3294344,
    height: 4.3294344,
    x: 88.599998,
    y: 118.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g724",
    style: {
      display: "inline",
      fill: "#e3dedb"
    },
    transform: "translate(-3.8394934)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect684",
    width: 4.3294344,
    height: 4.3294344,
    x: 94,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect686",
    width: 4.3294344,
    height: 4.3294344,
    x: 94,
    y: 140.60002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect688",
    width: 4.3294344,
    height: 4.3294344,
    x: 94,
    y: 136.19989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect690",
    width: 4.3294344,
    height: 4.3294344,
    x: 94,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect692",
    width: 4.3294344,
    height: 4.3294344,
    x: 94,
    y: 127.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g776",
    style: {
      display: "inline",
      fill: "#e3dedb"
    },
    transform: "translate(-1.8394948)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect709",
    width: 4.3294344,
    height: 4.3294344,
    x: 99.400002,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect711",
    width: 4.3294344,
    height: 4.3294344,
    x: 99.400002,
    y: 140.60002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect713",
    width: 4.3294344,
    height: 4.3294344,
    x: 99.400002,
    y: 136.19989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect717",
    width: 4.3294344,
    height: 4.3294344,
    x: 99.400002,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect726",
    width: 4.3294344,
    height: 4.3294344,
    x: 103.8,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect728",
    width: 4.3294344,
    height: 4.3294344,
    x: 108.2,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect732",
    width: 4.3294344,
    height: 4.3294344,
    x: 103.8,
    y: 136.2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect734",
    width: 4.3294344,
    height: 4.3294344,
    x: 108.2,
    y: 136.2
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect736",
    width: 4.3294344,
    height: 4.3294344,
    x: 103.8,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect738",
    width: 4.3294344,
    height: 4.3294344,
    x: 108.2,
    y: 145
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect740",
    width: 4.3294344,
    height: 4.3294344,
    x: 112.6,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect742",
    width: 4.3294344,
    height: 4.3294344,
    x: 112.6,
    y: 140.60002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect744",
    width: 4.3294344,
    height: 4.3294344,
    x: 112.6,
    y: 136.19989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect746",
    width: 4.3294344,
    height: 4.3294344,
    x: 112.6,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect748",
    width: 4.3294344,
    height: 4.3294344,
    x: 112.6,
    y: 127.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g811",
    style: {
      display: "inline",
      fill: "#e3dedb"
    },
    transform: "translate(0.16050668)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect754",
    width: 4.3294344,
    height: 4.3294344,
    x: 118,
    y: 136.19989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect750",
    width: 4.3294344,
    height: 4.3294344,
    x: 118,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect752",
    width: 4.3294344,
    height: 4.3294344,
    x: 118,
    y: 140.60002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect756",
    width: 4.3294344,
    height: 4.3294344,
    x: 118,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect758",
    width: 4.3294344,
    height: 4.3294344,
    x: 118,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect780",
    width: 4.3294344,
    height: 4.3294344,
    x: 122.4,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect782",
    width: 4.3294344,
    height: 4.3294344,
    x: 126.8,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect784",
    width: 4.3294344,
    height: 4.3294344,
    x: 131.2,
    y: 136.19989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect786",
    width: 4.3294344,
    height: 4.3294344,
    x: 131.2,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect788",
    width: 4.3294344,
    height: 4.3294344,
    x: 131.2,
    y: 140.60002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect790",
    width: 4.3294344,
    height: 4.3294344,
    x: 131.2,
    y: 131.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g869",
    style: {
      display: "inline",
      fill: "#e3dedb"
    },
    transform: "translate(2.1605046)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect792",
    width: 4.3294344,
    height: 4.3294344,
    x: 141,
    y: 136.19989
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect794",
    width: 4.3294344,
    height: 4.3294344,
    x: 141,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect796",
    width: 4.3294344,
    height: 4.3294344,
    x: 141,
    y: 140.60002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect798",
    width: 4.3294344,
    height: 4.3294344,
    x: 141,
    y: 131.8
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect813",
    width: 4.3294344,
    height: 4.3294344,
    x: 136.60001,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect815",
    width: 4.3294344,
    height: 4.3294344,
    x: 141,
    y: 122.99993
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect817",
    width: 4.3294344,
    height: 4.3294344,
    x: 141,
    y: 127.39999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect819",
    width: 4.3294344,
    height: 4.3294344,
    x: 141,
    y: 118.6
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect821",
    width: 4.3294344,
    height: 4.3294344,
    x: 145.39999,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect823",
    width: 4.3294344,
    height: 4.3294344,
    x: 149.79999,
    y: 127.39999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect825",
    width: 4.3294344,
    height: 4.3294344,
    x: 145.39999,
    y: 127.4
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect827",
    width: 4.3294344,
    height: 4.3294344,
    x: 149.79999,
    y: 127.39999
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect871",
    width: 4.3294344,
    height: 4.3294344,
    x: 145.39354,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572747
    },
    id: "rect873",
    width: 4.3294344,
    height: 4.3294344,
    x: 149.78699,
    y: 145.00002
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.286158
    },
    id: "rect764",
    width: 2.161485,
    height: 2.1646886,
    x: 158.49171,
    y: 147.15079
  }), /*#__PURE__*/React.createElement("g", {
    id: "g868",
    style: {
      display: "inline"
    },
    transform: "matrix(0.49999838,0,0,0.49954862,78.170635,74.750186)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect797",
    width: 4.3294344,
    height: 4.3294344,
    x: 169.5211,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect799",
    width: 4.3294344,
    height: 4.3294344,
    x: 173.91455,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect801",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 140.60637
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect803",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 136.21292
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect805",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 131.81947
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect807",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 127.42608
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect809",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 123.03256
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect811",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 118.63914
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect814",
    width: 4.3294344,
    height: 4.3294344,
    x: 173.91455,
    y: 118.63914
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect816",
    width: 4.3294344,
    height: 4.3294344,
    x: 169.5211,
    y: 118.63914
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect820",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 123.03259
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect822",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 127.42603
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect824",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 131.81947
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect826",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 136.21291
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect828",
    width: 4.3294344,
    height: 4.3294344,
    x: 169.5211,
    y: 136.21292
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect830",
    width: 4.3294344,
    height: 4.3294344,
    x: 173.91455,
    y: 136.21292
  })), /*#__PURE__*/React.createElement("g", {
    id: "g904",
    style: {
      display: "inline"
    },
    transform: "matrix(0.49999838,0,0,0.49954862,89.154255,74.750186)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect872",
    width: 4.3294344,
    height: 4.3294344,
    x: 169.5211,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect874",
    width: 4.3294344,
    height: 4.3294344,
    x: 173.91455,
    y: 145.00002
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect876",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 140.60637
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect878",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 136.21292
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect880",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 131.81947
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect882",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 127.42608
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect884",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 123.03256
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect886",
    width: 4.3294344,
    height: 4.3294344,
    x: 178.308,
    y: 118.63914
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect888",
    width: 4.3294344,
    height: 4.3294344,
    x: 173.91455,
    y: 118.63914
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect890",
    width: 4.3294344,
    height: 4.3294344,
    x: 169.5211,
    y: 118.63914
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect892",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 123.03259
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect894",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 127.42603
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect896",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 131.81947
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect898",
    width: 4.3294344,
    height: 4.3294344,
    x: 165.12766,
    y: 136.21291
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect900",
    width: 4.3294344,
    height: 4.3294344,
    x: 169.5211,
    y: 136.21292
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#e3dedb",
      strokeWidth: 0.572752
    },
    id: "rect902",
    width: 4.3294344,
    height: 4.3294344,
    x: 173.91455,
    y: 136.21292
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cbdcf1156304969c1eb46c838110003d.svg";
export { ForwardRef as ReactComponent };